import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmojiBigSmile = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M7.75 8.25h-1m6.5 0h-1m6 1.75a8.25 8.25 0 1 1-16.5 0 8.25 8.25 0 0 1 16.5 0Zm-5.5 2.75c-1 3-4.5 3-5.5 0h5.5Z"
	})]
});
const ForwardRef = forwardRef(SvgEmojiBigSmile);
export { ForwardRef as ReactComponent };
